import storeModuleFactory from 'util/storeModule/storeModuleFactory';
import endpoints from 'config/endpoints';
import {TIMESTAMP_MULTIPLY, TIMEOUT_STORE} from 'util/constants';

const exports = storeModuleFactory({
    name:               'backupsDaily',
    endpoint:           endpoints.backupsDaily.endpoint,
    instanceEndpoint:   endpoints.backupsDaily.instanceEndpoint,
    timeout:            TIMEOUT_STORE.TIMEOUT_STORE_BIG,
    transformResultsFn: json => json,
    parseParameters:    params => ({
        startDate: Math.floor(params.startDate / TIMESTAMP_MULTIPLY),
        endDate:   Math.floor(params.endDate / TIMESTAMP_MULTIPLY),
        host:      params.host ? params.host.join() : undefined
    }),
    filterParamsMap: {
        startDate: 'start_date',
        endDate:   'end_date'
    },
    transformEntitiesFn: json => {
        const date = json.date * TIMESTAMP_MULTIPLY;

        return {
            date,
            day:  (new Date(date)).getDate(),
            size: json.backup_size
        };
    }
});


module.exports = exports;



// WEBPACK FOOTER //
// ./src/modules/store/backupsDaily.js